import React, {FC, useEffect, useRef} from 'react'
import {KTSVG, QUERIES} from '../../../../_metronic/helpers'
import {SearchComponent} from '../../../../_metronic/assets/ts/components'
import {useQuery} from '@tanstack/react-query'
import {getLocations, getMetadata} from '../../../modules/apps/location/list/core/_requests'
import {useFormik} from 'formik'
import {getServices} from '../../../modules/apps/service/list/core/_requests'
import {useIntl} from 'react-intl'
import {getCategorys} from '../../../modules/apps/service/category/core/_requests'

const Search: FC<any> = ({filter, setFilter}) => {
  const intl = useIntl()
  // const {filter, setFilter} = useContext(QueryContext)
  const element = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    // Initialize search handler
    SearchComponent.createInsance('#kt_header_search')
  }, [])

  const {data: cities} = useQuery(
    [`${QUERIES.METADATA_LIST}-city`],
    () => {
      return getMetadata('city')
    },
    {keepPreviousData: true}
  )
  const {data: states} = useQuery(
    [`${QUERIES.METADATA_LIST}-state`],
    () => {
      return getMetadata('state')
    },
    {keepPreviousData: true}
  )
  const {data: countries} = useQuery(
    [`${QUERIES.METADATA_LIST}-country`],
    () => {
      return getMetadata('country')
    },
    {keepPreviousData: true}
  )
  const {data: category} = useQuery(
    [`${QUERIES.CATEGORYS_LIST}`, `filter=${JSON.stringify({status: true})}`],
    () => {
      return getCategorys(`filter=${JSON.stringify({status: true})}`)
    },
    {keepPreviousData: true}
  )
  const {data: service} = useQuery(
    [`${QUERIES.SERVICES_LIST}`, `filter=${JSON.stringify({status: true})}`],
    () => {
      return getServices(`filter=${JSON.stringify({status: true})}`)
    },
    {keepPreviousData: true}
  )
  const {data: location} = useQuery(
    [`${QUERIES.LOCATIONS_LIST}`, `filter=${JSON.stringify({status: true})}`],
    () => {
      return getLocations(`filter=${JSON.stringify({status: true})}`)
    },
    {keepPreviousData: true}
  )
  const formik = useFormik({
    initialValues: {},
    // validationSchema: loginSchema,
    onSubmit: async (values) => {
      setFilter({...filter, ...values})
    },
  })

  return (
    <>
      <div
        id='kt_header_search'
        className='d-flex align-items-stretch'
        data-kt-search-keypress='true'
        data-kt-search-min-length='2'
        data-kt-search-enter='enter'
        data-kt-search-layout='menu'
        data-kt-menu-trigger='auto'
        data-kt-menu-overflow='false'
        data-kt-menu-permanent='true'
        data-kt-menu-placement='bottom-end'
        ref={element}
      >
        <div
          className='d-flex align-items-center'
          data-kt-search-element='toggle'
          id='kt_header_search_toggle'
        >
          <div className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'>
            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-1' />
          </div>
        </div>

        <div
          data-kt-search-element='content'
          className='menu menu-sub menu-sub-dropdown p-7 w-325px w-md-375px'
        >
          <input data-kt-search-element='input' className='d-none' />

          <form className='pt-1'>
            {/* <h3 className='fw-bold text-dark mb-7'>Advanced Search</h3>

            <div className='mb-5'>
              <input
                type='text'
                className='form-control form-control-sm form-control-solid'
                placeholder='Contains the word'
                {...formik.getFieldProps('search')}
              />
            </div> */}
            <h6 className='fw-bold text-dark mb-7'>
              Filter by {intl.formatMessage({id: 'Service'})}
            </h6>
            <div className='mb-5'>
              <select
                aria-label='Select a Category'
                className='form-select form-select-sm form-select-solid'
                {...formik.getFieldProps('category_id')}
              >
                <option value=''>-- {intl.formatMessage({id: 'Service'})} Category --</option>
                {category?.entities?.map((e, i) => (
                  <option value={e.id} key={i}>
                    {e.name}
                  </option>
                ))}
              </select>
            </div>
            <div className='mb-5'>
              <select
                aria-label='Select a Service'
                className='form-select form-select-sm form-select-solid'
                {...formik.getFieldProps('service_id')}
              >
                <option value=''>-- {intl.formatMessage({id: 'Service'})} --</option>
                {service?.entities?.map((e, i) => (
                  <option value={e.id} key={i}>
                    {e.name}
                  </option>
                ))}
              </select>
            </div>
            <h6 className='fw-bold text-dark mb-7'>Filter by Location</h6>

            <div className='mb-5'>
              <select
                aria-label='Select a Location'
                className='form-select form-select-sm form-select-solid'
                {...formik.getFieldProps('location_id')}
              >
                <option value=''>-- Location --</option>
                {location?.entities?.map((e, i) => (
                  <option value={e.id} key={i}>
                    {e.name}
                  </option>
                ))}
              </select>
            </div>
            <div className='row mb-8'>
              <div className='mb-5 col-6'>
                <select
                  aria-label='Select a Country'
                  className='form-select form-select-sm form-select-solid'
                  {...formik.getFieldProps('country')}
                >
                  <option value=''>-- Country --</option>
                  {countries?.entities?.map((e, i) => (
                    <option value={e.value} key={i}>
                      {e.value}
                    </option>
                  ))}
                </select>
              </div>
              <div className='mb-5 col-6'>
                <select
                  aria-label='Select a State'
                  className='form-select form-select-sm form-select-solid'
                  {...formik.getFieldProps('state')}
                >
                  <option value=''>-- State --</option>
                  {states?.entities?.map((e, i) => (
                    <option value={e.value} key={i}>
                      {e.value}
                    </option>
                  ))}
                </select>
              </div>
              <div className='mb-5 col-6'>
                <select
                  aria-label='Select a City'
                  className='form-select form-select-sm form-select-solid'
                  {...formik.getFieldProps('city')}
                >
                  <option value=''>-- City --</option>
                  {cities?.entities?.map((e, i) => (
                    <option value={e.value} key={i}>
                      {e.value}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='d-flex justify-content-end'>
              {/* <button
                onClick={(e) => {
                  e.preventDefault()
                  setMenuState('main')
                }}
                className='btn btn-sm btn-light fw-bolder btn-active-light-primary me-2'
              >
                Cancel
              </button> */}

              <button
                type='button'
                onClick={() => formik.handleSubmit()}
                className='btn btn-sm fw-bolder btn-primary'
                data-kt-search-element='advanced-options-form-search'
              >
                Search
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export {Search}
